// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
    text-align: center;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 30px;
}

li {
    display: inline-block;
    position: relative;
    text-align: center;
    width: 80px;
}

li::before {
    content: '';
    position: absolute;
    border: 1px solid #404141;
    border-bottom: none;
    top:10px;
    left: 40px;
    right: -50px;
    z-index:-1;
}

li:first-child:before {
    display: none
}

li:last-child:before {
    display: none;
}


li:nth-last-child(2):before {
    display: none
}


li.home {
    margin-right: 75px;
    width: 40px;
}

li.home.home-narrow {
    margin-right: 30px;
}

li.overview {
    margin-left: 75px;
    width: 55px;
}

li.overview.overview-narrow {
    margin-left: 30px;
}

button {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
  letter-spacing: 0.01px;
  padding: 0px;
  text-decoration: none;
}

button div {
    margin-bottom: 10px;
}

button:focus {
    border-bottom: thin solid #BFBFC0;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}

li.disabled {
    cursor: not-allowed;
}

li.long-text::before {
    top: 28px;
}

button.disabled {
    pointer-events: none !important;
    opacity: 1;
}

button img {
    display: block;
    margin: auto;
    width: 19px;
    height: 19px;
}

button div.image {
    display: block;
    margin: auto;
    width: 19px;
    height: 19px;
}

button.active div.navicon {
    content: url('Active.svg');
    background-color: white;
}

button.active div.navicon:after {
    content: url('Active.svg');
    background-color: white;
}

button div.navicon {
    background: url('Empty.svg');
    background-color: white;
}

button div.navicon:after {
    content: url('Empty.svg');
    background-color: white;
}

button div.navicon.complete {
    content: url('Complete.svg');
    background-color: white;
}

button div.navicon.complete:after {
    content: url('Complete.svg');
    background-color: white;
}

button.active div.navicon.complete {
    content: url('Active.svg');
    background-color: white;
}

button.active div.navicon.complete:after {
    content: url('Active.svg');
    background-color: white;
}

button div.navicon.error {
    content: url('Error_nav.svg');
    background-color: white;
}

button div.navicon.error:after {
    content: url('Error_nav.svg');
    background-color: white;
}

button div.navicon.complete.error {
    content: url('Error_nav.svg');
    background-color: white;
}

button.active div.navicon.error {
    content: url('Error_nav.svg');
    background-image: url('Active.svg');
}

button.active div.navicon.error:after {
    background: transparent;
}

button div.navicon.complete.error:after {
    content: url('Error_nav.svg');
    background-color: white;
}

button.active div.navicon.complete.error {
    content: url('Error_nav.svg');
    background-image: url('Active.svg');
}

button.active div.navicon.complete.error:after {
    background: transparent;
}

button.long-text {
    margin-top:18px;
    white-space: initial;
    -webkit-hyphens: auto;
    hyphens: auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/navbar.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI;AACJ;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,0BAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,4BAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,yBAAgD;IAChD,uBAAuB;AAC3B;;AAEA;IACI,4BAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,4BAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,0BAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,0BAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,6BAAoD;IACpD,uBAAuB;AAC3B;;AAEA;IACI,6BAAoD;IACpD,uBAAuB;AAC3B;;AAEA;IACI,6BAAoD;IACpD,uBAAuB;AAC3B;;AAEA;IACI,6BAAoD;IACpD,mCAA0D;AAC9D;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAAoD;IACpD,uBAAuB;AAC3B;;AAEA;IACI,6BAAoD;IACpD,mCAA0D;AAC9D;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IAGrB,aAAa;AACjB","sourcesContent":["ul {\n    text-align: center;\n    padding: 0;\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 30px;\n}\n\nli {\n    display: inline-block;\n    position: relative;\n    text-align: center;\n    width: 80px;\n}\n\nli::before {\n    content: '';\n    position: absolute;\n    border: 1px solid #404141;\n    border-bottom: none;\n    top:10px;\n    left: 40px;\n    right: -50px;\n    z-index:-1;\n}\n\nli:first-child:before {\n    display: none\n}\n\nli:last-child:before {\n    display: none;\n}\n\n\nli:nth-last-child(2):before {\n    display: none\n}\n\n\nli.home {\n    margin-right: 75px;\n    width: 40px;\n}\n\nli.home.home-narrow {\n    margin-right: 30px;\n}\n\nli.overview {\n    margin-left: 75px;\n    width: 55px;\n}\n\nli.overview.overview-narrow {\n    margin-left: 30px;\n}\n\nbutton {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n  letter-spacing: 0.01px;\n  padding: 0px;\n  text-decoration: none;\n}\n\nbutton div {\n    margin-bottom: 10px;\n}\n\nbutton:focus {\n    border-bottom: thin solid #BFBFC0;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n\nli.disabled {\n    cursor: not-allowed;\n}\n\nli.long-text::before {\n    top: 28px;\n}\n\nbutton.disabled {\n    pointer-events: none !important;\n    opacity: 1;\n}\n\nbutton img {\n    display: block;\n    margin: auto;\n    width: 19px;\n    height: 19px;\n}\n\nbutton div.image {\n    display: block;\n    margin: auto;\n    width: 19px;\n    height: 19px;\n}\n\nbutton.active div.navicon {\n    content: url('../../../assets/images/Active.svg');\n    background-color: white;\n}\n\nbutton.active div.navicon:after {\n    content: url('../../../assets/images/Active.svg');\n    background-color: white;\n}\n\nbutton div.navicon {\n    background: url('../../../assets/images/Empty.svg');\n    background-color: white;\n}\n\nbutton div.navicon:after {\n    content: url('../../../assets/images/Empty.svg');\n    background-color: white;\n}\n\nbutton div.navicon.complete {\n    content: url('../../../assets/images/Complete.svg');\n    background-color: white;\n}\n\nbutton div.navicon.complete:after {\n    content: url('../../../assets/images/Complete.svg');\n    background-color: white;\n}\n\nbutton.active div.navicon.complete {\n    content: url('../../../assets/images/Active.svg');\n    background-color: white;\n}\n\nbutton.active div.navicon.complete:after {\n    content: url('../../../assets/images/Active.svg');\n    background-color: white;\n}\n\nbutton div.navicon.error {\n    content: url('../../../assets/images/Error_nav.svg');\n    background-color: white;\n}\n\nbutton div.navicon.error:after {\n    content: url('../../../assets/images/Error_nav.svg');\n    background-color: white;\n}\n\nbutton div.navicon.complete.error {\n    content: url('../../../assets/images/Error_nav.svg');\n    background-color: white;\n}\n\nbutton.active div.navicon.error {\n    content: url('../../../assets/images/Error_nav.svg');\n    background-image: url('../../../assets/images/Active.svg');\n}\n\nbutton.active div.navicon.error:after {\n    background: transparent;\n}\n\nbutton div.navicon.complete.error:after {\n    content: url('../../../assets/images/Error_nav.svg');\n    background-color: white;\n}\n\nbutton.active div.navicon.complete.error {\n    content: url('../../../assets/images/Error_nav.svg');\n    background-image: url('../../../assets/images/Active.svg');\n}\n\nbutton.active div.navicon.complete.error:after {\n    background: transparent;\n}\n\nbutton.long-text {\n    margin-top:18px;\n    white-space: initial;\n    -webkit-hyphens: auto;\n    -moz-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
